import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {},

  getters: {},
  actions: {
    createSaleTarget({ commit, dispatch }, model) {
      return ajax.post("/Sales/api/SaleTargets", model).then((response) => {
        return response;
      });
    },
    deleteSaleTarget({ commit, dispatch }, model) {
      return ajax
        .delete(
          "/Sales/api/SaleTargets",
          { data: model },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          return response;
        });
    },
  },
  mutations: {},
};
